import {configureStore} from '@reduxjs/toolkit'
import eqFiltersReducer from './counter/eqFiltersReducer'
import globalReducer from './counter/globalReducer'

const store = configureStore({
    reducer: {
        filters: eqFiltersReducer,
        global: globalReducer,
    },

});

export default store;